import React, { Component } from 'react';
import * as autoActions from '../store/action/auth'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'
import { renderField } from '../utils/reduxField';
import { ToastContainer, toast } from 'react-toastify'
import StorageService from '../services/StorageService';
import { CONSTS } from '../config/Constant';
import ApiService from "../services/ApiService";
import Cookies from 'js-cookie'
import localStore from 'src/utils/local-storage'
import { ReCaptcha } from 'react-recaptcha-v3';
import moment from 'moment'
import _ from 'lodash'
import {
  GoogleReCaptchaProvider,
  GoogleReCaptcha
} from 'react-google-recaptcha-v3';

const {
  REACT_APP_GOOGLE_KEY,
  REACT_APP_FE_URL,
  REACT_APP_TITLE
} = process.env;

class Login extends Component {
  constructor() {
    super();
    this.state = {
      isDisabled: false,
      isLoggedIn: false,
      loading: false,
      error: '',
      alert: {
        message: '',
        className: 'hidden',
        header: 'Error',
        captcha: null
      },
      accesstoken: Cookies.get("jwt") || ''
    };

  }

  componentDidMount() {
    document.body.classList.add('login-page');

    let { login } = this.props
    if (login.accesstoken) {
      setTimeout(() => {
        this.setState({
          isLoggedIn: true
        })
        toast.success("Login success!");
        this.props.history.push('/');
      }, 0)
    }
    if(this.state.accesstoken){
      setTimeout(() => {
        this.setState({
          isLoggedIn: true
        })
        toast.success("Login success!");
        this.props.history.push('/');
      }, 0)
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { statusLogin } = nextProps.login;
    const { login } = this.props
    if (login.statusLogin != statusLogin && statusLogin === 2) {

      if (!toast.isActive("loginpage")) {
        toast.success("Login success!", {
          toastId: "loginpage"
        })
      }

      this.setState({ error: '' }, () => {
        StorageService.set(CONSTS.STORE_KEYS.USER.PROFILE, nextProps.login.userInfo);
        StorageService.set(CONSTS.STORE_KEYS.USER.TOKEN, nextProps.login.accesstoken);
        this.props.history.push('/posts');
      });

    }
    if (login.statusLogin != statusLogin && statusLogin === 3) {
      this.setState({ error: 'Wrong username or password' });
      if (!toast.isActive("loginpage")) {
        toast.error("Login failed!", {
          toastId: "loginpage"
        })
      }
    }
  }

  componentWillUnmount() {
    document.body.classList.remove('login-page');
  }


  handleSubmit() {
    const { userEmail, userPassword } = this.props;

    this.setState({
      loading: true, isDisabled: true
    })


    setTimeout(() => {


      const data = {
        identifier: userEmail,
        password: userPassword
      };
      // this.props.loginAction(data)

      ApiService.post(`/auth/local`, data).then(result => {
        if (result) {
          this.setToken(result);
        } else {
          toast.error('Không thể đăng nhập vào lúc này!', {
            toastId: "loginpage"
          })
        }
      }).catch(error => {
        if (!toast.isActive("loginpage")) {

          let msg = _.get(error, 'messages[0].message[0].messages[0].message') || "Login failed";
          toast.error(msg, {
            toastId: "loginpage"
          })
        }
      });
      this.setState({ loading: false, isDisabled: false, isLoggedIn: true })

    }, 2000)
  }

  verifyCallback = (recaptchaToken) => {
    this.setState({ captcha: recaptchaToken });
    //6Lc1iecUAAAAAGgSciZlMZmfVxFI_xPYc83r11SA
    //6Lc1iecUAAAAABcyPy4JM-82xHvaTYCru2_nYt_K
  }

  setToken = result => {
    if (!process.browser) {
      return;
    }
    const user = result.user;

    Cookies.set("jwt", result.jwt, { expires: 1 });
    Cookies.set("user_id", user.id, { expires: 1 });

    localStore.set('_user', user);
    if (!toast.isActive("loginpage")) {
      toast.success("Login success!", {
        toastId: "loginpage"
      })
    }

    this.setState({ error: '' }, () => {
      //store ip v4 to sessionStorage
      StorageService.set(CONSTS.STORE_KEYS.USER.PROFILE, result.user);
      StorageService.set(CONSTS.STORE_KEYS.USER.TOKEN, result.jwt);
      // this.props.history.push('/posts');
      
      const previousURL = document.referrer;
      const homepage = process.env.REACT_APP_HOMEPAGE;

      if (previousURL && previousURL.includes(homepage)) {
        window.location.href = previousURL;
      } else {
        window.location.href = '/';
      }
    });



  };
  render() {
    let disableButtonSaveStyle = { cursor: 'pointer' };
    const { captcha } = this.state;

    const { valid, pristine, userEmail, userPassword } = this.props;

    if (!valid || pristine || !userEmail || !userPassword || !captcha) {
      disableButtonSaveStyle.opacity = 0.5;
      disableButtonSaveStyle.pointerEvents = 'none';
    }

    return (
      <div className="login-box">
        <div className="login-logo">
    <a href={REACT_APP_FE_URL} ><b>{REACT_APP_TITLE}</b></a>
        </div>

        <div className="card">
          <div className="card-body login-card-body">
            <p className="login-box-msg">Sign in to start your session</p>

            <form>

              <Field classinput="input-group mb-3"
                classgroup="fas fa-envelope" id="email" name="email" type="text" component={renderField} label="Email" />

              <Field classinput="input-group mb-3"
                classgroup="fa fa-lock" id="password" name="password" type="password" component={renderField} label="Password" />



              <div className="form-group">
                <p className="text-red">{this.state.error}</p>
              </div>
              <div className="row">
                <div className="col-12">
                  <button type="button" className="btn btn-primary btn-block"  onClick={() => this.handleSubmit()}>Sign In</button>
                </div>

              </div>
            </form>
          </div>

        </div>

      </div>
    );
  }
  //================================ END =============================
}
const selector = formValueSelector('formLogin');
Login = reduxForm({
  form: 'formLogin'
})(Login)
export default connect(store => {
  return {
    login: store.loginInfo,
    form: store.formLogin,
    userEmail: selector(store, 'email'),
    userPassword: selector(store, 'password'),
  };
}, dispatch => {
  return {
    loginAction: (value) => { dispatch(autoActions.loginToBackEnd(value)) }
  }
})(Login)
